/**
 * Mixed ballistic rounds. One unit is one round, so weight scales with what a magazine actually
 * holds rather than with a box nobody counted.
 */

import type { AmmoItem } from '@/sim/items/itemContract';

export const BALLISTIC_ROUNDS = {
  id: 'ballisticRounds',
  kind: 'ammo',
  label: 'Ballistic rounds',
  description: 'Brass, mismatched headstamps, a little green. Fires anyway, most of the time.',
  rarity: 'common',
  weightKg: 0.012,
  stackLimit: 240,
  equip: null,
  damageTypeId: 'ballistic',
  roundsPerUnit: 1,
} as const satisfies AmmoItem;
